import React, {useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listUserPlaylists } from '../../actions/PlaylistActions'
import arrowLeft from '../icons/Arrow_left.svg'
import { useNavigate, useNavigationType } from 'react-router-dom';
import { formatSeconds } from '../../utils/formatTime'
import IconDeletePlaylist from '../icons/IconDeletePlaylist.svg'
import { deletePlaylist } from '../../actions/PlaylistActions';

const PlaylistsUser = () => {

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const navigationType = useNavigationType();

    const userPlaylistsRef = useRef(null);

    const playlistList = useSelector(state => state.userPlaylists)
  
    const { loading, userPlaylists} = playlistList
  
    useEffect(()=>{
        dispatch(listUserPlaylists())
        localStorage.setItem("path", `/myPlaylists`)
        window.scrollTo(0, 0)
    },[dispatch])


    const handleScroll = event => {

        const {scrollTop, clientHeight, scrollHeight} = event.currentTarget;
        sessionStorage.setItem("results-scroll", scrollTop);

      } 

    useEffect(()=>{
        if(userPlaylists && userPlaylists.length && navigationType === "POP"){    
            userPlaylistsRef.current.scrollTo({
                top: sessionStorage.getItem("results-scroll") || 0,
                behavior: "auto"
            })
        }
    },[userPlaylists])



    
    const playlistClickHandler = (playlist) => { 

        localStorage.setItem("video_id", playlist.video_id)
        localStorage.setItem("playlist_id", playlist.id)
        navigate(`/home?v=${playlist.video_id}&p=${playlist.id}`)
    }
    
    const deletePlaylistHandler = (e,playlist) =>{
        e.stopPropagation()
        var answer = window.confirm("Do you really want to delete the playlist?");
        if (answer) {
            dispatch(deletePlaylist(playlist.id))
        }
    }   

    return (
        <>
            <div className = "w-100 bg-bluedark d-flex flex-column align-items-center page-bg-fill">
                    <div className = "w-100 d-flex flex-column align-items-center"
                        style={{maxHeight:"calc(100vh - 5rem)"}}>
                    
                    { 
                        loading ? <div className = "text-info col-12 col-lg-10" >Loading...</div> :
                        <>
                        <div className = 'w-100 pt-3 pt-md-5 pb-2 d-flex justify-content-center'>
                            <div className = "col-12 col-lg-10 d-flex flex-column flex-md-row justify-content-center align-items-start">
                                <div className = 'col-12 col-md-6 px-3 px-md-5 d-flex align-items-center justify-content-start'>
                                    <img
                                        src = {arrowLeft}
                                        role = 'button'
                                        onClick={()=>navigate(-1)}
                                        alt = ''
                                        className='flex-shrink-0'
                                        style={{height:"17px", width:"auto"}}
                                        />
                                    <div className='ps-3 text-white fs-7 page-title text-truncate flex-grow-1'
                                        style={{minWidth:0}}
                                    >My Playlists</div>
                                </div>
                                <div className='col-12 col-md-6 d-flex px-2 px-md-5 justify-content-end'>
                                    {
                                        userPlaylists && userPlaylists.length ?
                                        <>
                                            <div className = "text-info px-3 text-nowrap">{userPlaylists.length} Videos</div>
                                            <div className = "text-info px-3 border-start border-info text-nowrap">{formatSeconds(userPlaylists.reduce((sum, item) => sum + item.duration, 0))} </div>

                                        </>: ""
                                    }
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-lg-10 px-4 pb-5 d-flex flex-row flex-wrap results-wrapper'
                            ref={userPlaylistsRef}
                            onScroll = {handleScroll}>
                                {
                                    userPlaylists && userPlaylists.length ? 
                                    userPlaylists.map((playlist)=>(
                                        <div className='col-6 col-md-4 col-lg-3 p-2 p-md-3 rounded position-relative'>
                                            <div className='position-absolute p-3 mt-0 me-0'
                                                role='button'
                                                onClick={(e)=>deletePlaylistHandler(e,playlist)}
                                                style={{top:"0", right: "0"}}
                                            >
                                                <img 
                                                    src = {IconDeletePlaylist}
                                                    alt = ""
                                                />
                                            </div>
                                            <img 
                                                src={`https://img.cugate.com/?o=CUTV_PLAYLIST&i=${playlist.id}&s=300`}
                                                alt=''
                                                className='rounded w-100'
                                                style={{ aspectRatio: "16/9" }}
                                                role='button'
                                                onClick={()=> playlistClickHandler(playlist)}
                                            />
                                            <div className='position-absolute p-2 p-md-3 text-white rounded bg-transparent'
                                                style={{zIndex:"1000", bottom:"0", right:"0"}}>
                                                    <div className='bg-dark p-1'
                                                    >{formatSeconds(playlist.duration)}</div>
                                            </div>
                                        </div>
                                    )) : ""
                                }

                        </div>
                        </>
                    }
                    
                </div>  
            </div>
        </>
    );
};

export default PlaylistsUser;